import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FirebaseService } from 'src/app/services/firebase.service';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-gracias-cotizador-persona-natural',
  templateUrl: './gracias-cotizador-persona-natural.component.html',
  styleUrls: ['./gracias-cotizador-persona-natural.component.scss']
})
export class GraciasCotizadorPersonaNaturalComponent implements OnInit {

  idCotizacion;
  cotizacion;

  accesos = [
    'Acceso total al sistema web',
    'Acceso total al APP mobil',
    'Central de Emergencias 24x7x365',
    'Notificación de alertas y alarmas',
    'Recuperación de vehículos robados',
    'Flotas administrables',
    'Geo-cercas virtuales',
    'Multi usuarios a todo nivel',
    'Perfiles de conductor',
    'Reportes generales y personalizables',
    'Diversas cartografías',
    'Historial de datos (hasta 24 meses)',
    'Tracking para análisis de recorrido',
    'Integración con BD externos',
    'Soporte técnico 24x7',
    'Integración de diversos sensores'
  ];

  logosAcreditados;

  constructor(
    private fs: FirebaseService,
    private activatedRoute: ActivatedRoute,
    private ds: DataService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe( params => {
      this.idCotizacion = params.id;

      this.fs.getCotizacionPersonaNatural(this.idCotizacion).subscribe(res => {
        this.cotizacion = res;
        console.log(JSON.stringify(this.cotizacion));
      });
    });
    this.logosAcreditados = this.ds.logosAcreditados;
  }

}
